module.exports = __webpack_public_path__ + "static/rod_of_rulership-8126aebcfdc1c6cbd9fed9e6b0419df2.jpeg";